import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { AnimationState } from '../reducers/animations/animations.reducer';

export const getAnimationsState = createFeatureSelector<
  AppState,
  AnimationState
>('animations');

export const getIsAnimationVisible = createSelector(
    getAnimationsState,
  (state: AnimationState) => state.visible
);
